<template>
<!-- <img ref="svgImgSrc" src="./../assets/NS_Siteplan.svg" @load="windowResizeChange" hidden/> -->
<img ref="a1" src="./../assets/Cambridge_Strip_Elevation.jpg" hidden/>
<img ref="c1" src="./../assets/Cambridge_Strip_Elevation.jpg" hidden/>
<img ref="e1" src="./../assets/Edinburgh_Strip_Elevation.jpg" hidden/>
<img ref="n1" src="./../assets/Nottingham_Strip_Elevation.jpg" hidden/>
    <div class="site_plan">
        <div class="leftPanel" v-if="isWideScreen">
            <div class="titleText">Explore the available models</div>
            <div class="underTitleText">Select your preferred model to see locations.</div>
            <div class="select_form">
              <div class="model_selection_header">
                <label class="select_label">Select Model</label>
                <label class="select_label show_all" @click="{floorplan=''; filterModelChange('')}">Show All</label>
              </div>
              <!-- <select v-model="floorplan" @change="filterModelChange">
                  <option value="" selected>All Models</option>
                  <option value="The Austin">The Austin</option>
                  <option value="The Brookline">The Brookline</option>
                  <option value="The Carmel">The Carmel</option>
                  <option value="The Durham">The Durham</option>
                  <option value="The Evanston">The Evanston</option>
              </select> -->
              <div class="radio_selection">
                <!-- <button :class="{ active_model: floorplan=='The Aberdeen'}" @click="filterModelChange('The Aberdeen')">
                  <div class="square aberdeen"></div>
                  <div>
                    <div class="model_title">The Aberdeen</div>
                    <div class="price_text">From $800s</div>
                  </div>
                  <div class="pic_holder" v-show="floorplan=='The Aberdeen'">
                    <img class="eye_img" src="./../assets/view.png"/>
                  </div>
                </button> -->
                <button :class="{ active_model: floorplan=='The Cambridge'}" @click="filterModelChange('The Cambridge')">
                  <div class="square cambridge" ></div>
                  <div>
                    <div class="model_title">The Cambridge</div>
                    <div class="price_text">{{ cambridgePrice }}</div>
                  </div>
                  <div class="pic_holder" v-show="floorplan=='The Cambridge'">
                    <img class="eye_img" src="./../assets/view.png"/>
                  </div>
                </button>
                <button :class="{ active_model: floorplan=='The Edinburgh'}" @click="filterModelChange('The Edinburgh')">
                  <div class="square edinburgh"></div>
                  <div>
                    <div class="model_title">The Edinburgh</div>
                    <div class="price_text">{{ edinburghPrice }}</div>
                  </div>
                  <div class="pic_holder" v-show="floorplan=='The Edinburgh'">
                    <img class="eye_img" src="./../assets/view.png"/>
                  </div>
                </button>
                <button :class="{ active_model: floorplan=='The Nottingham'}" @click="filterModelChange('The Nottingham')">
                  <div class="square nottingham"></div>
                  <div>
                    <div class="model_title">The Nottingham</div>
                    <div class="price_text">{{ nottinghamPrice }}</div>
                  </div>
                  <div class="pic_holder" v-show="floorplan=='The Nottingham'">
                    <img class="eye_img" src="./../assets/view.png"/>
                  </div>
                </button>
              </div>
            </div>
            <div class="select_form">
              <label class="select_label">Status</label>
              <select v-model="status" @change="filterStatusChange">
                <option value="" selected>All</option>
                <option value="Available">Available</option>
                <option value="ComingSoon">Coming Soon</option>
                <option value="Sold" >Sold</option>
              </select>
            </div>
            <div class="checkbox-group">
              <input type="checkbox" v-model="showOnlyElevator" id="showOnlyElevator" @change="iterateSVG" />
              <label for="showOnlyElevator">Show only homes with elevator option</label>
            </div>
            <button class="downloadButton" @click="downloadSitePlan"><img src="../assets/button-download-icon.svg"/>DOWNLOAD SITE PLAN</button>
            <div class="statusLegend">
              <div class="legendItem"><div class="availableCircle"></div>Available</div>
              <div class="legendItem"><div class="soldCircle"></div>Sold</div>
              <div class="legendItem"><div class="modelCircle"></div>Model Home</div>
              <div class="legendItem"><img class="legendIcon" src="../assets/elevator-icon.svg"/>Elevator Option Available</div>
            </div>
        </div>
        <div class="topPanel" v-if="!isWideScreen">
          <div class="titleText">Explore the available models</div>
          <div class="underTitleText">Select your preferred model to see locations.</div>
        </div>
        <div class="midPanel">
          <div id="siteplanImage" ref="siteplanImgContainer" >
            <div ref="svgDiv" id="svgImage"><div class="loaderContainer"><div class="loader"></div></div></div>
          </div>
          <div id="buttonSide">
              <button class="actionButton">
                  <img class="legendButtonImg" ref="zoomInRef" src="./../assets/plus-circle.svg" />
              </button>
              <button class="actionButton">
                <img class="legendButtonImg" ref="zoomOutRef" src="./../assets/minus-circle.svg" />
              </button>
              <button class="actionButton">
                <img class="legendButtonImg" ref="zoomResetRef" src="./../assets/sync-alt.svg" />
              </button>
          </div>
        </div>
        <div class="bottomPanel" v-if="!isWideScreen">
          <div class="select_form">
            <div class="model_selection_header">
                <label class="select_label">Select Model</label>
                <label class="select_label show_all" @click="{floorplan=''; filterModelChange('')}">Show All</label>
            </div>
            <div class="radio_selection">
                <!-- <button :class="{ active_model: floorplan=='The Aberdeen'}" @click="filterModelChange('The Aberdeen')">
                  <div class="square aberdeen"></div>
                  <div>
                    <div class="model_title">The Aberdeen</div>
                    <div class="price_text">From $800s</div>
                  </div>
                  <div class="pic_holder" v-show="floorplan=='The Aberdeen'">
                    <img class="eye_img" src="./../assets/view.png"/>
                  </div>
                </button> -->
                <button :class="{ active_model: floorplan=='The Cambridge'}" @click="filterModelChange('The Cambridge')">
                  <div class="square cambridge" ></div>
                  <div>
                    <div class="model_title">The Cambridge</div>
                    <div class="price_text">{{ cambridgePrice }}</div>
                  </div>
                  <div class="pic_holder" v-show="floorplan=='The Cambridge'">
                    <img class="eye_img" src="./../assets/view.png"/>
                  </div>
                </button>
                <button :class="{ active_model: floorplan=='The Edinburgh'}" @click="filterModelChange('The Edinburgh')">
                  <div class="square edinburgh"></div>
                  <div>
                    <div class="model_title">The Edinburgh</div>
                    <div class="price_text">{{ edinburghPrice }}</div>
                  </div>
                  <div class="pic_holder" v-show="floorplan=='The Edinburgh'">
                    <img class="eye_img" src="./../assets/view.png"/>
                  </div>
                </button>
                <button :class="{ active_model: floorplan=='The Nottingham'}" @click="filterModelChange('The Nottingham')">
                  <div class="square nottingham"></div>
                  <div>
                    <div class="model_title">The Nottingham</div>
                    <div class="price_text">{{ nottinghamPrice }}</div>
                  </div>
                  <div class="pic_holder" v-show="floorplan=='The Nottingham'">
                    <img class="eye_img" src="./../assets/view.png"/>
                  </div>
                </button>
              </div>
          </div>
          <div class="select_form">
            <label class="select_label">Status</label>
            <select class="mobile" v-model="status" @change="filterStatusChange">
              <option value="" selected>All</option>
              <option value="Available">Available</option>
              <option value="ComingSoon">Coming Soon</option>
              <option value="Sold" >Sold</option>
            </select>
          </div>
          <div class="checkbox-group">
              <input type="checkbox" v-model="showOnlyElevator" id="showOnlyElevator" @change="iterateSVG" />
              <label for="showOnlyElevator">Show only homes with elevator option</label>
          </div>
          <button class="mobilDownloadButton" @click="downloadSitePlan"><img src="../assets/button-download-icon.svg"/>DOWNLOAD SITE PLAN</button>
          <div class="statusLegend">
              <div class="legendItem"><div class="availableCircle"></div>Available</div>
              <div class="legendItem"><div class="soldCircle"></div>Sold</div>
              <div class="legendItem"><div class="modelCircle"></div>Model Home</div>
              <div class="legendItem"><img class="legendIcon" src="../assets/elevator-icon.svg"/>Elevator Option Available</div>
            </div>
        </div>
       
    </div>
   

  <Teleport to="body">
    <!-- use the modal component, pass in the prop -->
    <unit-modal :isWideScreen="isWideScreen" :show="showUnitModal" :showForm="showEmbedForm" :lotId="selectedLotId" @close="showUnitModal = false, showEmbedForm = false">
      <template #header>
          <div class="lotName">{{ modalTitleText }}</div>
          
      </template>
      <template #body>
        <div class="modalAboveImageText">
          <div class="modalFloorplanName">{{ lotFloorplanName }}</div>
          <div class="modalInfotext" v-if="lotUnitInfoText">{{ lotUnitInfoText }}</div>
          <div class="modalInfotext">{{ lotPriceText }}</div>
        </div>
        <img :src="getImageURL()" class="modalImagePreview"/>
        <!-- <div>{{ lotPriceText }}</div> -->
        
        <!-- <div>{{ lotBedroomsText.toUpperCase() }}</div>
        <div>{{ lotBathroomsText.toUpperCase() }}</div>
        <div>{{ lotSizeText.toUpperCase() }}</div>
        <div>{{ lotParkingSpaceText.toUpperCase() }}</div>
        <div>{{ lotPriceText.toUpperCase() }}</div> -->
        <!-- <embed src="https://share.hsforms.com/170dZipQbSgKLuc9t_WTxtw11shp" height="400"> -->
        <a v-if="lotFloorplanName != 'The Aberdeen'" target="_parent" class="modalLink" :href="getFloorplanURL()">View Floor Plan Details</a>
        <button class="formButton" @click="showEmbedForm = true">Contact Me About This Home</button>
      </template>
    </unit-modal>
  </Teleport>
    <Teleport to="body">
    <!-- use the modal component, pass in the prop -->
    <filter-modal :show="showFilterModal" @close="showFilterModal = false" @filter="iterateSVG" :testWidth="200">
      <template #header>
      </template>
      <template #body>
      </template>
    </filter-modal>
  </Teleport>
  <Teleport to="body">
    <loading-modal :show="showLoadingModal">
    </loading-modal>
  </Teleport>
</template>
<style scoped lang="scss">
.loaderContainer{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.loader {
  border: 1rem solid #f3f3f3; /* Light grey */
  border-top: 1rem solid #D0713E; /* Blue */
  border-radius: 50%;
  width: 5rem;
  height: 5rem;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.formButton{
    border-radius: 0.25rem;
    height: 2.8rem;
    color: white;
    background-color: #007fad;
    border: none;
    font-family:'Roboto', sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem; /* 133.333% */
    margin-top: 1rem;
    margin-left: auto;
    margin-right: auto;
    font-size: large;
    margin-bottom: 0.5rem;
    margin-top: 1.4rem;
    width: 20rem;
}
.site_plan{
    display: flex;
    flex-direction: row;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}
.availableCircle{
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    border-radius: 0.75rem;
    border: 0.0625rem solid #FFF;
    background: #0b7f43;
}
.soldCircle{
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    border-radius: 0.75rem;
    border: 0.0625rem solid #FFF;
    background: #F60808;
}
.modelCircle{
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    border-radius: 0.75rem;
    border: 0.0625rem solid #000;
    background: #FFF;
}

@media only screen and (max-width: 1024px){
  .site_plan{
    flex-direction: column;
    padding: 1rem;
  }
  .topPanel{
    text-align: left;
      .titleText{
      font-size: 1.7rem;
      line-height: 1.08em;
      font-family:'SangBleu OG';
      padding-bottom: 1rem;
      color: #131e29;
    }
    .underTitleText{
      font-size: 1.125rem;
      padding-bottom: 1rem;
    }
  }
  .downloadButton{
    margin-right: 0rem !important;
    width: 100%;
  }
  .bottomPanel{
    margin-top: 1rem;
  }
}
#legend{
  text-align: center;
  color: #6F7070;
  background-color: white;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  padding-top: 0.4em;
  z-index: 15;
  position: fixed;
  height: 2em;
}
.leftPanel{
  flex-shrink: 0;
  padding-left: 5%;
  padding-right: 2rem;
  width: 23.625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  .titleText{
    font-size: 3.125rem;
    font-family:'SangBleu OG';
    line-height: 1.08em;
    padding-bottom: 1rem;
    color: #131e29;
  }
  .underTitleText{
    font-size: 1.125rem;
    padding-bottom: 3rem;
  }
}
.midPanel{
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
#siteplanImage{
    background-color: white;
    flex-grow: 0;    
    height: 100%;
    max-height: 1080px;
    width: 100%;
}
#svgImage{
   height: 100%;
   max-height: 650px;
  // margin-left: auto;
  // margin-right: auto;
}
#buttonSide{
    right: 0.1rem;//v-bind(controlRightOffest);
    width: fit-content;
    background-color: #EFEFEF;
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    float: right;
    border: solid 1px #BFBFBF;
    border-radius: 0.2rem;
    height: 2rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    gap: 0.4rem;
    padding: 0 0.4rem;
    align-self: flex-end;
    .actionButton{
      border: none;
      width: 2rem;
      height: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: none;
    }
    .legendButtonImg{
      width: 1.5rem;
      height: 1.5rem;
    }
}
.select_form{
    select{
        background-repeat: no-repeat;
        background-position: right center;
        background-size: contain;
        background-color: #ffffff;
        padding: 15px 44px 15px 15px;
        border: 0.0625rem solid #E0E0E0;
        color: #131E29;
        font-size: 1rem;
        font-family:'Roboto', sans-serif;
        font-weight: 400;
        letter-spacing: 0.08px;
        line-height: 1rem;
        appearance: none;
        background-image: url(../assets/dropdown--bg.svg);
        width: 100%;
        max-width: 100%;
        margin-bottom: 1rem;
        height: auto;
        transition: all .3s ease-in-out;
        &:focus{
            outline: none;
        }
        &:disabled{
            background-color: var(--background-color);   
            background-image: url(../assets/dropdown--disabled.svg);
        }
        &:hover{
          background-image: url(../assets/dropdown--hover.svg);
          transition: all .3s ease-in-out;
        }
    }
    .mobile{
      padding: 13px 44px 13px 15px;
    }
    .select_label{
      color: #747474;
      padding-bottom: 0.5rem;
      display: block;
      font-size: 1rem;
      font-weight: 400;
      text-align: left;
    }
    .show_all{
      color:#907147;
    }
    .show_all:hover{
      text-decoration: underline;
    }
}
.model_selection_header{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.radio_selection{
  margin-bottom: 1rem;
  display: flex;
  flex-flow: column;
  label > input[type=radio]{
    visibility: hidden;
    display: none;
  }
  label{
    display: flex;
    flex-flow: row;
    align-content: center;
    border-bottom: solid 0.1rem #e0e0e0;
    padding: 0.4rem 1rem;
  }
  button{
    display: flex;
    flex-flow: row;
    align-content: center;
    border: none;
    border-bottom: solid 0.1rem #e0e0e0;
    padding: 0.4rem 1rem;
    background: none;
  }
  
  .active_model{
    background: #f5f5f5;
  }

  label:first-child{
    border-top: solid 0.0625rem #e0e0e0;
  }
  label:hover{
    background: #f5f5f5;
  }
  .square{
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    margin-right: 1rem;
    border-radius: 0.25rem;
    background-color: red;
    align-self: center;
  }.aberdeen{
    background-color: #027A91;
  }
  .cambridge{
    background-color: #D09302;
  }
  .edinburgh{
    background-color: #781C53;
  }
  .nottingham{
    background-color: #BD4627;
  }


  .model_title{
    text-align: left;
    font-size:1.3rem;
    font-weight: 700;
    color: #131E29;
  }
  .price_text{
    text-align: left;
    color: #747474;
    font-size: 0.9rem;
  }
  .pic_holder{
    align-self: center;
    flex: 1;
  }
  .eye_img{
    width: 1.6rem;
    float: right;
  }
}

.checkbox-group {
  display: flex;
  align-items: flex-start;
  grid-template-columns: 1em auto;
  gap: 0.5em;
  padding-top: 0.5rem;
  label{
    font-size: 1.125rem;
    letter-spacing: 0.09px;
    line-height: 1.5rem;
    flex-shrink: 1;
  }
 input[type="checkbox"] {
    flex-shrink: 0;
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: var(--form-background);
    /* Not removed via appearance */
    margin: 0;

    font: inherit;
    width: 1.5rem;
    height: 1.5rem;
    border: 0.15em solid #D0713E;
    border-radius: 0.25rem;
    transform: translateY(-0.075em);

    display: grid;
    place-content: center;
    }

    input[type="checkbox"]::before {
    content: "";
    width: 0.9em;
    height: 0.9em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    //clip-path: polygon(8% 39%, 0 49%, 44% 81%, 100% 14%, 90% 5%, 43% 66%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    //box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: #fff;
    }

    input[type="checkbox"]:checked::before {
        transform: scale(1);
    }

    input[type="checkbox"]:checked{
        background: #D0713E;
    }

    input[type="checkbox"]:disabled {
    --form-control-color: var(--form-control-disabled);

    color: var(--form-control-disabled);
    cursor: not-allowed;
    }
}

.downloadButton{
  border-radius: 0.25rem;
  border: 2px solid #D0713E;
  display: flex;
  background-color: #D0713E;
  height: 2.8125rem;
  padding: 0.5rem 1.5rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  color: #FFF;
  text-align: center;
  font-family:'Roboto', sans-serif;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem; /* 133.333% */
  letter-spacing: 0.1125rem;
  text-transform: uppercase;
  margin-top: 2rem;
  width: fit-content;
  transition: all .3s ease-in-out;
  img{
    transition: all .3s ease-in-out;
    }
  &:hover {
    background-color: #FFF;
    border: 2px solid #D0713E;
    transition: all .3s ease-in-out;
    color: #D0713E;
    img{
      transition: all .3s ease-in-out;
      filter: invert(50%) sepia(21%) saturate(1433%) hue-rotate(337deg) brightness(97%) contrast(88%)
    }
  }
}

.mobilDownloadButton{
  border-radius: 0.25rem;
  border: 2px solid #D0713E;
  display: flex;
  background-color: #D0713E;
  height: 2.8125rem;
  padding: 0.5rem 1.5rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  color: #FFF;
  text-align: center;
  font-family:'Roboto', sans-serif;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem; /* 133.333% */
  letter-spacing: 0.1125rem;
  text-transform: uppercase;
  margin-top: 2rem;
  width: 100%;
  transition: all .3s ease-in-out;
  img{
    transition: all .3s ease-in-out;
    }
  &:hover {
    background-color: #FFF;
    border: 2px solid #D0713E;
    transition: all .3s ease-in-out;
    color: #D0713E;
    img{
      transition: all .3s ease-in-out;
      filter: invert(50%) sepia(21%) saturate(1433%) hue-rotate(337deg) brightness(97%) contrast(88%)
    }
  }
}

#zoomInBtn{
  background-image: url('./../assets/plus-circle.png');
}
#zoomOutBtn{
  background-image: url('./../assets/minus-circle.png');
}
#zoomResetBtn{
  background-image: url('./../assets/reset-view-icon.png');
}
#filterBtn{
  background-image: url('./../assets/filter.png');
}
.modalImagePreview{
    max-width: 100%;
    max-height: 55vh;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 0.5rem;
}
.statusLegend{
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  .legendIcon{
    width: 1.5rem;
    height: 1.5rem;
  }
  .legendItem{
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
}
//TODO set media query to make different right for vh100 +200px for buttonside or make site plan smaller
@media only screen and (max-width: 1042px){
  .modalImagePreview{
    max-width: 100%;
    //width: 300px;
  }
  #buttonSide{
    position: relative;
    float: right;
    bottom: 1rem;
    top: 0.5rem;
    right: 0.5rem;
    height: fit-content;
    display: flex;
    flex-direction: row-reverse;
    align-self: flex-end;
    width: fit-content;
  }
  #svgImage{
    height: 100%;
  }
  #siteplanImage{
    flex-grow: 1;    
    max-height: 100%;
}
  .site_plan{
    height: 100%;
  }
  .midPanel{
    display: flex;
    flex-direction: column;
  }
}

#bottomLogoImg{
  position: relative;
  width: 80%;
  margin-bottom: 6%;
}
.modalFloorplanName{
  font-weight: 700;
  color: #131E29;
  font-size: 1.4rem;
}

.modalAboveImageText{
  text-align: left;
  padding-left: 1.5rem;
  padding-bottom: 1rem;
}
.modalLink{
  text-decoration: none;
  color: #007fad;
  font-size: 1rem;
}
.modalInfotext{
  font-size: 0.9rem;
  font-weight: 500;
  color: #131E29;
}
</style>
<script setup lang="ts">
import axios from "axios";
import { onMounted, ref, watch } from "vue";
import Panzoom from "@panzoom/panzoom";
import { appStore } from "@/stores/app-store";
import { BuildingData } from "@/stores/app-state";
import UnitModal from '@/components/UnitModal.vue';
import FilterModal from '@/components/FilterModal.vue';
import LoadingModal from '@/components/LoadingModal.vue';
const store = appStore();

const svgImgSrc = ref();
const svgDiv = ref();
const a1 = ref();
const c1 = ref();
const e1 = ref();
const n1 = ref();



const showUnitModal = ref(false);
const showEmbedForm = ref(false);
const showFilterModal = ref(false);
const selectedLotId = ref('');
const modalTitleText = ref();
const lotPriceText = ref();
const lotBedroomsText = ref();
const lotBathroomsText = ref();
const lotSizeText = ref();
const lotParkingSpaceText = ref();
const lotFloorplanName = ref('');
const lotUnitInfoText = ref();

const showLoadingModal = ref(false);

const zoomInRef = ref();
const zoomOutRef = ref();
const zoomResetRef = ref();
const siteplanImgContainer = ref();
const controlRightOffest = ref('15px');

const cambridgePrice = ref("From $1.2M");
const edinburghPrice = ref("From $1.4M");
const nottinghamPrice = ref("From $1.5M");

let unitsAvailable = ref(0);
let currentFloorplanIndex = ref(0);

let panning = false;
let panzoom:any;

let floorplan = ref(store.floorplanFilter);
let status = ref(store.statusFilter);
const showOnlyElevator = ref(false);

const isWideScreen = ref(true);

let theBarnLogoElement:any;

watch(showUnitModal, (newShow, oldShow) => {
    if(newShow){
      document.body.classList.add("modal-open");
    }else{
      document.body.classList.remove("modal-open");
    }
});

onMounted(() => {
    // let svgSource = svgImgSrc.value.src;
    var svgHtml = document.querySelector('#svgImage');
    axios.get("NS_Siteplan.svg").
    then((data:any) => {
        store.siteSVG = data.data;
        svgDiv.value.innerHTML = store.siteSVG;
        initPanzoom();
        axios.get("https://homedesigner.truevistavr.com/siteplanAPI/siteplan/NS")
          .then((data:any) => {
           store.unitsData = data.data;
            updateBuildingPhaseData();
            iterateSVG();
          });
    });
    window.addEventListener("resize", windowResizeChange);
    windowResizeChange();
    axios.get("https://homedesigner.truevistavr.com/siteplanAPI/prices/3")
          .then((data:any) => {
            data.data.forEach((element:any) => {
              switch(element.name){
                case 'The Aberdeen':
                  break;
                case 'The Cambridge':
                  cambridgePrice.value = element.pricing;
                  break;
                case 'The Edinburgh':
                  edinburghPrice.value = element.pricing;
                  break;
                case 'The Nottingham':
                  nottinghamPrice.value = element.pricing;
                  break;
                default:
                  break;
              }
            });
           });
});

const windowResizeChange = () => {
  if(siteplanImgContainer.value.clientWidth > siteplanImgContainer.value.clientHeight){
    controlRightOffest.value = 
    ((siteplanImgContainer.value.clientWidth - siteplanImgContainer.value.clientHeight) / 2) + 15 + "px";
  }else{
    controlRightOffest.value = "15px";
  }
  isWideScreen.value = window.innerWidth >= 1024;// || (window.matchMedia("(orientation: landscape)").matches);
};
function updateBuildingPhaseData(){
  let futurePhaseDate = store.futurePhaseBuildings;
  futurePhaseDate.forEach(building => {
    let enabled = true;
    store.unitsData.every(unit=>{
      if(+unit.unitId >= building.startUnit && +unit.unitId <= building.endUnit
      && unit.status != "ComingSoon"){
          enabled = false;
          return false;
      }
      return true;  
    });
    building.enabled = enabled;
  });
}

function filterModelChange(newFilter:string){
  if(floorplan.value == newFilter){
    floorplan.value = "";
  }else{
    floorplan.value = newFilter;
  }
  console.log("Filter changed");
  store.floorplanFilter = floorplan.value;
  iterateSVG();
}

function filterStatusChange(){
  store.statusFilter = status.value != "All"? status.value : "";
  if(status.value == "All"){
    status.value = "";
  }
  //var startTime = performance.now();
  iterateSVG();
  //var endTime = performance.now();
  //console.log(`Call to doSomething took ${endTime - startTime} milliseconds`);
}


function iterateSVG() {
    var svgHtml = document.querySelector('#svgImage');
    //svgHtml!.innerHTML = store.siteSVG; //TODO remove this line to increase peformance by 50-100x times but need to deal with sold circles then.
    unitsAvailable.value = 0;

    let svg = svgDiv.value.children[0];
    svg.querySelectorAll('circle').forEach((element:any) => {
      let elementClass = element.getAttribute('class');
      if(elementClass == "tempCircle"){
        element.remove();
      }
    });

    svg.querySelectorAll('g').forEach((element:any) => {
    let elementID = element.getAttribute('id');

    if(elementID == null)
      return;

      if(elementID == "TheBarnLogo"){
        theBarnLogoElement = element;
      }

     elementID = elementID.substring(1);
    let findEl = store.unitsData.find((obj:any) => {return obj.unitId === elementID});
    let rectElem = element.querySelector('rect');

    if (rectElem == null) rectElem = element.querySelector('path');
    
    if(elementID.startsWith('building')){
      let findBuilding = store.futurePhaseBuildings.find((obj:any) => {return obj.id == elementID});
      let textElem = element.querySelector('text');
      element.style="pointer-events: none;";
      //TODO make replace to dynamic not static replace
      textElem.style = textElem.getAttribute('style').replace('\'BrandonGrotesque-Bold\', \'Brandon Grotesque\', sans-serif', '\'Brandon Groeteque Bold\'');
      if(findBuilding == null || !findBuilding.enabled 
        || store.floorplanFilter != '' || store.statusFilter != ''){
        element.visibility = 'hidden';
        element.setAttribute('visibility', 'hidden');
      }
    }

    let futurePhase = false;
    if(store.floorplanFilter == '' && store.statusFilter == '')
    store.futurePhaseBuildings.forEach((building:BuildingData) => {
      if(!building.enabled) return;
      if(elementID >= building.startUnit && elementID <= building.endUnit){
        // element.visibility = 'hidden';
        // element.setAttribute('visibility', 'hidden');
        futurePhase = false;
        return;
      }
    });

    if(findEl == null || rectElem == null)
      return;

    let triangleElem;
    let allPaths = element.querySelectorAll('path');
    if(allPaths.length == 2){
      triangleElem = allPaths[1];
    }else if(allPaths.length == 1 && allPaths[0] != rectElem){
      triangleElem = allPaths[0];
    }

    if(triangleElem != null){
        triangleElem.style = "fill:white;pointer-events: none;";
    }

    rectElem.onclick = ()=>{ 
      if(panning) return;
      if(findEl!.status == "AFF") return;
      lotFloorplanName.value = findEl!.floorPlanName;
      selectedLotId.value = findEl!.unitName;
      modalTitleText.value = "Homesite "+findEl!.unitName;
      lotPriceText.value = findEl!.status == "Available"?
      `$${(findEl!.startingPrice*1000).toLocaleString("EN-US")}`: "";
      if(findEl!.status == "ComingSoon") lotPriceText.value = "Coming Soon";
      lotBedroomsText.value = `Bedrooms: ${findEl!.minBedrooms} - ${findEl!.maxBedrooms}`;
      lotBathroomsText.value = `Baths: ${findEl!.minBathrooms} - ${findEl!.maxBathrooms}`;
      lotSizeText.value = `Size: ${findEl!.minSqft.toLocaleString()} - ${findEl!.maxSqft.toLocaleString()} sq. ft.`;
      lotParkingSpaceText.value = `Parking Space: ${findEl!.parkingSpace}-Car Garage`;
      lotUnitInfoText.value = findEl!.infoText;
      showUnitModal.value = true;
      currentFloorplanIndex.value = getFloorplanIndexFromName(findEl!.floorPlanName);
    };

    let textElem = element.querySelector('text');
    //TODO make replace to dynamic not static replace 
    textElem.style = textElem.getAttribute('style').replace('\'BrandonGrotesque-Medium\', \'Brandon Grotesque\', sans-serif', '\'Brandon Groeteque Med\'');
    let prevTextStyle = textElem.getAttribute('style');
    let textColor = "fill:white;";
 


    rectElem.style = getFloorplanStyle(findEl!.floorPlanName, futurePhase ? "ComingSoon":findEl!.status);

    let boundingBox = element.getBBox();
    //console.log(element.getBBox());
    let x = boundingBox.x;//rectElem.x.baseVal.value;
    let y = boundingBox.y;//rectElem.y.baseVal.value;
    let width = boundingBox.width;//rectElem.width.baseVal.value;
    let height = boundingBox.height;//rectElem.height.baseVal.value;
    let xOffset = elementID < 7 || elementID > 66 ? 4 : 4;
    let yOffset = elementID < 7 || elementID > 66 ? 0 : -3;

    if((findEl.status == "Unavailable" || futurePhase || findEl.status == "AFF")
      && store.statusFilter != 'ComingSoon'){
        textColor = "fill:none;"
        //rectElem.onclick = () => {return false};
    }

    let cplace = element.querySelector('circle');
    if(cplace){
      cplace.style = 'cursor: default;pointer-events: none;fill:none;';
    }

    let floorplanCheck = store.floorplanFilter != '' && store.floorplanFilter != findEl?.floorPlanName;
    let statusCheck = store.statusFilter != '' && store.statusFilter != findEl.status;
    let elevatorCheck = showOnlyElevator.value && triangleElem == null;

    if((floorplanCheck || statusCheck || elevatorCheck) && !futurePhase){
      textColor = "fill:grey;"

      if (findEl.status == "AFF"){
        textColor = "fill:none;"
      }

      if(triangleElem != null){
        triangleElem.style = "fill:grey;pointer-events: none;";
      }

      rectElem.style = 'fill:#00000096;cursor: default;';
    }else if(findEl.status == "Sold" && !futurePhase){
      addSoldCircle();
    }else if(findEl.status == "Model" && !futurePhase){
      addModelCircle();
    }else if(findEl.status == "Available" && !futurePhase){
      addAvailableCircle();
    }

    textElem.style = prevTextStyle+=';cursor: default;pointer-events: none;'+textColor;
    
    function addModelCircle() {
      let cx=x+width/2-4+xOffset;
      let cy=y+height/2+3+yOffset;
      let textX=x+width/2-13.5+xOffset;
      let textY=y+height/2+6+yOffset;
      if(cplace!=null) {
        cx=cplace.cx.baseVal.value;
        cy=cplace.cy.baseVal.value;
        textX=cx-13.5;
        textY=cy+4.5;
      }
      var circle2=makeSVG('circle', {class:"tempCircle", cx: cx, cy: cy, r: 30, stroke: '#131E29', 'stroke-width': 4, fill: 'White', style: "default;pointer-events: none;" });
      // var text2=makeSVG('text', { x: textX, y: textY, style: "font-family: 'DIN-Condensed'; font-weight:700;font-size:13px;fill:#00599E; default;pointer-events: none;" });
      // text2.textContent="MODEL";
      element.appendChild(circle2);
      // element.appendChild(text2);
    }

  function addSoldCircle() {
    let cx=x+width/2-4+xOffset;
    let cy=y+height/2+3+yOffset;
    let textX=x+width/2-13+xOffset;
    let textY=y+height/2+6.5+yOffset;
    if(cplace!=null) {
      cx=cplace.cx.baseVal.value;
      cy=cplace.cy.baseVal.value;
      textX=cx-25;
      textY=cy+10;
    }
    var circle=makeSVG('circle', {class:"tempCircle", cx: cx, cy: cy, r: 30, stroke: 'white', 'stroke-width': 3, fill: '#F60808', style: "default;pointer-events: none;" });
    //var text=makeSVG('text', { x: textX, y: textY, style: "font-family: 'D-DIN Condensed'; font-weight:400;font-size:30px;fill:white; default;pointer-events: none;" });
    //text.textContent="SOLD";
    element.appendChild(circle);
    //element.appendChild(text);
  }
   function addAvailableCircle() {
    let cx=x+width/2-4+xOffset;
    let cy=y+height/2+3+yOffset;
    if(cplace!=null) {
      cx=cplace.cx.baseVal.value;
      cy=cplace.cy.baseVal.value;
    }
    var circle=makeSVG('circle', { cx: cx, cy: cy, r: 30, stroke: 'white', 'stroke-width': 3, fill: '#0b7f43', style: "default;pointer-events: none;" });
    element.appendChild(circle);
  }
});
}   


function initPanzoom(){
    var element = document.querySelector('#svgImage');
    let startX = 50;
    let startY = 45;
    let startScale = 2.3;
    if(!isWideScreen.value){
      startX = 45;
      startY = 35;
      startScale = 1.7;
    }

    panzoom = Panzoom(element, {
        maxScale: 5,
        minScale: 1,
        startScale: startScale,
        startY: startY,
        startX: startX,
        animate: true,
        duration: 100,
        cursor: 'default',
        contain:"outside"
      });
    element!.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);

    var timeout:any;
    element.addEventListener('panzoomchange', function(event){
        panning = true;
        // if(event.detail.scale > 1.5){
        //   theBarnLogoElement!.setAttribute('visibility', 'hidden');
        // }else{
        //   theBarnLogoElement!.setAttribute('visibility', 'visible');
        // }
        window.clearTimeout(timeout);
        timeout = setTimeout(() => {
            panning = false;
        }, 100);
    });

    zoomInRef.value.onclick = ()=>{ panzoom.zoomIn(); };
    zoomOutRef.value.onclick = ()=>{ panzoom.zoomOut(); };
    zoomResetRef.value.onclick = ()=>{ 
      panzoom.reset();
      store.floorplanFilter = '';
      store.statusFilter = '';
      showOnlyElevator.value = false;
      iterateSVG();
    };
}

function getFloorplanStyle(floorPlanName:string, lotStatus:string){
  let default_cursor = "pointer"
    if(lotStatus == "AFF"){
      default_cursor = "default";
    }
    switch (floorPlanName) {
        case "The Aberdeen":
            //return lotStatus == "Unavailable" || lotStatus == "ComingSoon" ? 
              //'fill:#D9D2A0FF;stroke:rgb(149,145,144);stroke-width:2px;cursor: default;':
              // if(store.siteFilter.floorPlanName == "The Atwood"){
              //   default_stroke = "white";
              // }
            return `fill:#027A9100;cursor: ${default_cursor};`;
        case "The Cambridge":
            //return lotStatus == "Unavailable" || lotStatus == "ComingSoon" ?
              //'fill:#14779AFF;stroke:rgb(149,145,144);stroke-width:2px;cursor: default;':
            return  `fill:#D0930200;cursor: ${default_cursor};`;
        case "The Edinburgh":
            //return lotStatus == "Unavailable" || lotStatus == "ComingSoon" ?
              //'fill:#C67C7CFF;stroke:rgb(149,145,144);stroke-width:2px;cursor: default;':
            return `fill:#781C5300;cursor: ${default_cursor};`;
        case "The Nottingham":
            return `fill:#BD462700;cursor: ${default_cursor};`;
        default:
            return "";
    }
}



function makeSVG(tag:string, attrs:any) {
    var el= document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs)
        el.setAttribute(k, attrs[k]);
    return el;
}
function getFloorplanIndexFromName(floorplanName:string){
  switch (floorplanName) {
    case 'The Aberdeen':
      return 0;
    case 'The Cambridge':
      return 1;
    case 'The Edinburgh':
      return 2;
    case 'The Nottingham':
      return 3;
    default:
      return 0;
  }
}
function getFilterInfoText(){
  switch(store.floorplanFilter){
     case 'The Bellair':
      return `SHOWING BELLAIR (${unitsAvailable.value} UNITS AVAILABLE)`;
    case 'The Cessna':
      return `SHOWING CESSNA (${unitsAvailable.value} UNITS AVAILABLE)`;
    case 'The Douglas':
      return `SHOWING DOUGLAS (${unitsAvailable.value} UNITS AVAILABLE)`;
    default:
      return ``;
  }
}

function statusToText(status:string){
  switch (status) {
    case "ComingSoon":
        return "Coming Soon"
    default:
      return status;      
  }
}

function getFloorplanURL(){
  switch (currentFloorplanIndex.value) {
        case 0:
            return "";
        case 1:
            return "https://www.eya.com/townhomes/potomac-md/northside/homes-floorplans/cambridge-model";
        case 2:
            return "https://www.eya.com/townhomes/potomac-md/northside/homes-floorplans/edinburgh-model";
        case 3:
            return "https://www.eya.com/townhomes/potomac-md/northside/homes-floorplans/nottingham-model";
        default:
            return "";
    }
}

function getImageURL():string{
  console.log(currentFloorplanIndex.value);
    switch (currentFloorplanIndex.value) {
        case 0:
            return a1.value.src;
        case 1:
            return c1.value.src;
        case 2:
            return e1.value.src;
        case 3:
            return n1.value.src;
        default:
            return a1.value.src;
   }
}

async function downloadSitePlan(){
  store.statusFilter = "";
  store.floorplanFilter = "";
  showOnlyElevator.value = false;
  iterateSVG();

  const svg = document.querySelector('svg');
  if(svg){
    showLoadingModal.value = true;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let widthFormatOk = svg.width.baseVal.value.toString() == svg.width.baseVal.valueAsString;
    let heightFormatOk = svg.width.baseVal.value.toString() == svg.height.baseVal.valueAsString;
    let defaultWidth = '';
    let defaultHeight = '';
    if (!widthFormatOk || !heightFormatOk) {
      let viewBox = svg.viewBox.baseVal;
      if(viewBox){
        defaultWidth = svg.width.baseVal.valueAsString;
        defaultHeight = svg.height.baseVal.valueAsString;
        //iOS canvas limit is 4096x4096 pixels
        let scaleRatio = 4096 / viewBox.height;

        svg.setAttribute("width", (Math.floor(viewBox.width * scaleRatio)).toString());
        svg.setAttribute("height", (4096).toString());
        canvas.width = Math.floor(viewBox.width * scaleRatio);
        canvas.height = 4096;
      }
    }
    //theBarnLogoElement!.setAttribute('visibility', 'hidden');

    const xml = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    img.src = 'data:image/svg+xml;base64,' + btoa(xml);

    img.onload = async function() {
    ctx!.fillStyle = "white";
    ctx!.fillRect(0, 0, canvas.width, canvas.height);

    let i = 0;
    let maxAttempts = 25;
    let repeat = true;
    let cycle = [];
    let dataURL = "";

    while (repeat && i < maxAttempts){
      console.log(i);
      ctx!.drawImage(img, 0, 0);
      await new Promise((resolve)=>{
        setTimeout(() => resolve(null), 100)
      })
      dataURL = canvas.toDataURL("image/jpeg", 0.8);
      console.log("Data Size = ",dataURL.length);
      i++;
      cycle[i] = dataURL.length;

      if (dataURL.length >= cycle[i - 1]) repeat = false;
    }
    console.log("Finish draw");
    panzoom.reset();

    svg.setAttribute("width", defaultWidth);
    svg.setAttribute("height", defaultHeight);
    iterateSVG();
    // put file into form data
    var formdata = new FormData();
    formdata.append("siteplanImg", dataURL);
    console.error("Siteplan size:" + dataURL.length)
    const response = await fetch('https://homedesigner.truevistavr.com/fileAPI/siteplan/northside',{
      method: "POST",
      //TODO add some floorplan identifier number so know which page to use
      body: formdata
    })
    .then(res => {
      if(res.ok){
        return res.blob()
      }
      throw new Error('Error occured')
    })
    .then(data  => {
      console.log(data)
      var a = document.createElement("a")
      a.href = window.URL.createObjectURL(data)
      a.download = "EYA Northside - Siteplan.pdf"
      a.click()
      showLoadingModal.value = false
    })
    .catch((error) => {
      console.log(error)
      showLoadingModal.value = false
    })
  }
  } 
} 

</script>